/**
 * CSV the way spreadsheets actually read it.
 *
 * This started in the invoice module's bank-file writer and moved here when
 * the feedback board needed the same escaping. Any screen offering a
 * download should use it rather than joining strings with commas: the
 * formula guard below is not optional when the text came from a user.
 */

// A leading =, +, - or @ makes a spreadsheet treat the cell as a formula. The
// text in these files reaches us from creators and from anyone who can type
// into a feedback box, so it is attacker-controlled text on its way into
// someone's Excel. A leading apostrophe defuses it.
const FORMULA_START = /^[=+\-@]/;

export function csvCell(value) {
  const raw = value === null || value === undefined ? '' : String(value);
  const safe = FORMULA_START.test(raw) ? `'${raw}` : raw;
  return /[",\n\r]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
}

/** RFC 4180 with CRLF line endings, which is what banks and Excel parse. */
export function toCsv(rows) {
  const list = Array.isArray(rows) ? rows : [];
  return list.map((row) => (row || []).map(csvCell).join(',')).join('\r\n');
}
